var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"option"},[_c('input',_vm._b({attrs:{"type":"checkbox"},on:{"change":_vm.onChange}},'input',_vm.checkboxProps,false)),_c('span',{staticClass:"checkbox"}),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }